import { Component } from '@angular/core';
import { IndexationReport } from '../shared/models/indexation-report.model';
import { StatsAndReportsService } from '../shared/services/stats-and-reports.service';

@Component({
  selector: 'app3-indexation-report',
  templateUrl: './indexation-report.component.html',
  styleUrls: ['./indexation-report.component.less'],
  standalone: false,
})
export class IndexationReportComponent {
  public indexationReport: IndexationReport;

  constructor(private statsAndReportsService: StatsAndReportsService) {}

  ngOnInit() {
    this.getIndexationReport();
  }

  getIndexationReport() {
    this.statsAndReportsService.getIndexationReport().subscribe((data: any) => {
      this.indexationReport = data;
    });
  }
}
